import Provider from "./AuthProvider";
import Authorized from "./Authorized";
import ServicesProvider from "./AuthServicesProvider";

export default {
  Provider,
  Authorized,
  ServicesProvider,
};
